













































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ChatStore from '@/components/Chat/Store/ChatStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { RequestMessage, IRequestMessage, AlteracaoDataMensagem, Snackbar } from '@/types/_'
import { DateTime } from 'luxon'
import { maskDateTime } from '@/utils/common'

import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentAlterarDataAgendamentoChat extends Vue {
  @Prop() tipoUsarioHospital: boolean
  @Prop({ required: false, default: 'auto' }) height: number | 'auto' | undefined
  @Prop({ required: false, default: false }) disabled: boolean

  mensagem: string = ''
  loadMensagem: boolean = false

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(value: string) {
    this.mensagem = value
  }

  get placeholder() {
    return this.disabled ? 'Escolha uma data para poder digitar uma mensagem...' : 'Mensagem'
  }

  clearMensagem() {
    this.getMensagem = ''
  }

  async send() {
    const responseMessage: IRequestMessage = new RequestMessage()
    this.loadingMensagem = true
    const mensagem: AlteracaoDataMensagem = {
      mensagemHospital: this.tipoUsarioHospital,
      hospitalId: '',
      dataEnvio: DateTime.local().toISO(),
      mensagem: this.$sanitize(this.getMensagem),
    }

    this.getMensagem = ''
    const response = await this.getChatStore.sendDataAgendamentoMensagem(mensagem)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingMensagem = false
  }

  positionRight(mensagemHospital: boolean) {
    return this.tipoUsarioHospital === mensagemHospital
  }

  positionLeft(mensagemHospital: boolean) {
    return this.tipoUsarioHospital !== mensagemHospital
  }

  formatHour(date) {
    return maskDateTime(date)
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('main-chat-scroll')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 200,
    }
    ele[0].scrollTo(option)
  }

  updated() {
    this.scrollToMensagem()
  }
}
